// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-type-list-items {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
.filter-products-count {
  font-size: 12px;
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
}
.apply-filters {
  background-color: #d2042d;
  color: #fff;
}
.filter-parent-card-section {
  width: 250px;
  height: 200px;
  overflow-y: scroll;
}
.details-section {
  width: 250px;
  margin-left: 8px;
  height: 280px;
  overflow-y: scroll;
}
.filter-lbels-txt {
  font-size: 14px;
  font-weight: 400;
}

.details-section-list {
  display: flex;
  align-items: center;
  gap: 16;
}
.filters-btns {
  display: flex;
  flex-direction: row;
}

.filters-render-filter-css {
  z-index: 1000;
  display: flex;
  position: absolute;
}
.product-type-filter-card {
  width: 250px;
  height: 425px !important;
  overflow-y: scroll;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.product-type-list-items {
  cursor: pointer;
  transition: all 0.2s;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/product-filters/ProductFilters.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".product-type-list-items {\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n}\n.filter-products-count {\n  font-size: 12px;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n}\n.apply-filters {\n  background-color: #d2042d;\n  color: #fff;\n}\n.filter-parent-card-section {\n  width: 250px;\n  height: 200px;\n  overflow-y: scroll;\n}\n.details-section {\n  width: 250px;\n  margin-left: 8px;\n  height: 280px;\n  overflow-y: scroll;\n}\n.filter-lbels-txt {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.details-section-list {\n  display: flex;\n  align-items: center;\n  gap: 16;\n}\n.filters-btns {\n  display: flex;\n  flex-direction: row;\n}\n\n.filters-render-filter-css {\n  z-index: 1000;\n  display: flex;\n  position: absolute;\n}\n.product-type-filter-card {\n  width: 250px;\n  height: 425px !important;\n  overflow-y: scroll;\n}\n\n.dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n\n.product-type-list-items {\n  cursor: pointer;\n  transition: all 0.2s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
